import type {Integer, Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {integerZodValidator, iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export enum StorageDatabaseStatus {
    active = "0ab40d78-2882-4f5e-88ee-53c614c3f68e",
    deleted = "3f7f9166-b063-4e5d-a8c5-50aafb1ed267",
}

export const storageDatabaseStatusLabel: Record<StorageDatabaseStatus, string> = {
    [StorageDatabaseStatus.active]: "Active",
    [StorageDatabaseStatus.deleted]: "Deleted",
};

export type StorageDatabase = {
    createdAt: Iso8601DateTime;
    createdBy: Uuid;
    dbName: string;
    displayName: string;
    host: string;
    id: Uuid;
    isDefault: boolean;
    port: Integer;
    readCredentials: string;
    status: StorageDatabaseStatus;
    superuserCredentials: string;
    updatedAt: Iso8601DateTime;
    updatedBy: Uuid;
    writeCredentials: string;
};

export const storageDatabaseValidator = zod.object({
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    dbName: zod.string(),
    displayName: zod.string(),
    host: zod.string(),
    id: uuidZodValidator,
    isDefault: zod.boolean(),
    port: integerZodValidator,
    readCredentials: zod.string(),
    status: zod.enum(StorageDatabaseStatus),
    superuserCredentials: zod.string(),
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
    writeCredentials: zod.string(),
});
